import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=3fcc30d6&scoped=true&"
import script from "./Referrals.vue?vue&type=script&lang=js&"
export * from "./Referrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc30d6",
  null
  
)

export default component.exports